import React, { Component } from 'react'
import { Steps, Form, Space, Button, Divider } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

interface StepFormItem {
  title: string,
  formName: string,
  formValues?: any,
  formLayout?: string
  render: (form?: any) => {}
}

type StepsFormProps = {
  steps: StepFormItem[],
  loading?: boolean,
  current?: number,
  onProceed?: (formName: string, values: any) => void,
  onFinish?: (values: Record<any, any>) => void
}

type StepsFormState = {
  current: number
}

export default class StepsForm extends Component<StepsFormProps, StepsFormState> {

  static defaultProps = {
    loading: false
  }

  state = {
    current: this.props.current || 0
  }

  forms: any[] = []

  handleNext = async () => {
    const { onProceed } = this.props
    const { current } = this.state
    const form = this.forms[current]

    if (form) {
      await form.ref.validateFields()

      if (onProceed) {
        const values = form.ref.getFieldsValue(true)
        onProceed(form.name, values)
      }

      this.setState(state => ({
        ...state,
        current: state.current + 1
      }))
    }
  }

  handlePrev = () => {
    this.setState(state => ({
      ...state,
      current: state.current - 1
    }))
  }

  handleSave = () => {
    const { onFinish } = this.props
    let values: Record<any, any> = {}

    this.forms.forEach(form => {
      values = {
        ...values,
        [form.name]: form.ref.getFieldsValue()
      }
    })

    if (onFinish) {
      onFinish(values)
    }
  }

  renderSteps = (step: StepFormItem, index: number) => {
    const { steps } = this.props
    const { current } = this.state
    if (!steps[current]) return null
    const hidden = steps[current].formName !== step.formName

    return (
      <Form
        key={`step-content-${index}`}
        name={step.formName}
        ref={refs => {
          if (!this.forms[index]) {
            this.forms[index] = {
              name: step.formName,
              ref: refs 
            }

            this.forceUpdate()
          }
        }}
        initialValues={step.formValues || {}}
        layout={step.formLayout as any || 'vertical'}
        hidden={hidden}
      >
        {this.forms[index]?.ref ? step.render(this.forms[index]) : null}
      </Form>
    )
  }

  render() {
    const { steps, loading } = this.props
    const { current } = this.state

    return (
      <>
        <Form.Provider>
          <Steps current={current}>
            {
              steps.map((item, index) => (
                <Steps.Step key={`step-${index}`} title={item.title} icon={loading ? <LoadingOutlined /> : null} />
              ))
            }
          </Steps>

          <Divider />

          {
            steps.map((item, index) => this.renderSteps(item, index))
          }
        </Form.Provider>

        <Space direction="horizontal">
          {
            current > 0 ? (
              <Button onClick={this.handlePrev} disabled={loading}>Previous</Button>
            ) : null
          }

          {
            current < steps.length - 1 ? (
              <Button type="primary" onClick={this.handleNext} disabled={loading}>Next</Button>
            ) : (
              <Button type="primary" onClick={this.handleSave} loading={loading}>Save</Button>
            )
          }
        </Space>
      </>
    )
  }
}
